import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import { DataTable, Grid, makeStyles, SMPopover, DialogViewInvoice } from "../../../..";
import RemoveRedEye from "@material-ui/icons/RemoveRedEye";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: "4px 25px"
    },
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-between"
    }
  };
});

var InvoicesCentral = function InvoicesCentral(_ref) {
  var invoices = _ref.invoices,
      getInvoice = _ref.getInvoice,
      options = _ref.options,
      language = _ref.language,
      translation = _ref.translation,
      props = _objectWithoutProperties(_ref, ["invoices", "getInvoice", "options", "language", "translation"]);

  var classes = useStyles();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openView = _React$useState2[0],
      setOpenView = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      selectedInvoice = _React$useState4[0],
      setSelectedInvoice = _React$useState4[1]; // console.log("translation InvoicesCentral", translation);
  // eslint-disable-next-line no-unused-expressions


  translation && translation.datatables && translation.datatables.invoices && translation.datatables.invoices.columns.find(function (column) {
    return column.name === "options";
  }) && (translation.datatables.invoices.columns.find(function (column) {
    return column.name === "options";
  }).options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return /*#__PURE__*/React.createElement(RemoveRedEye, {
        onClick: function onClick() {
          return handleViewInvoice(tableMeta.rowData[0]);
        }
      });
    }
  });

  var handleViewInvoice = function handleViewInvoice(id) {
    if (!openView) {
      // const invoice = invoices.find(invoice => invoice._id === id);
      // console.log("handleItemViewInvoice invoice", invoice);
      getInvoice(id).then(function (response) {
        // console.log("handleViewInvoice", response.data);
        setSelectedInvoice(_objectSpread({}, response.data));
      });
    } else {
      setSelectedInvoice(null);
    }

    setOpenView(!openView);
  };

  return [/*#__PURE__*/React.createElement(DialogViewInvoice, {
    variant: "subscription-view",
    locale: "ES",
    open: openView,
    onClose: function onClose() {
      setOpenView(false);
      setSelectedInvoice(null);
    },
    franchise: true,
    invoice: selectedInvoice,
    translation: translation ? translation.dialogs.view_invoice : null
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(DataTable, {
    key: language + "_invoices",
    options: options,
    data: invoices,
    translation: translation ? translation.datatables.invoices : null
  }))))];
};

export default InvoicesCentral;